import { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-bootstrap';
import dayjs from 'dayjs';

import { Table, TableBody, TableHead, TableCell, TableContainer, TableRow, Chip, Box, Tab } from '@mui/material';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';
// import TabPanel from '@mui/lab/TabPanel';

// import { getStationsCount } from 'components/axios/stationAxios';
import { getEquipmentsCount } from 'components/axios/equipmentAxios';
// import { getDashboardCountEquipmentAlertGroupByEquipmentCtgr1, getDashboardCountEquipmentAlertGroupByMonth, getDashboardCountEquipmentAlertGroupByMonthAndCategory1, getDashboardCountGroupByFollowActionType, getDashboardCountGroupByStatus } from 'components/axios/dashboardAxios';
import { getDashboardCountByCategoryAndEquipmentStatus, getDashboardCountEquipmentAlertGroupByMonthAndCategory1, getDashboardCountGroupByFollowActionType, getDashboardCountGroupByStatus } from 'components/axios/dashboardAxios';
import { useEnumApi } from 'contexts/EnumApiContext';
import MainCard from 'components/MainCard';
// import TrainMap from 'components/TrainMap';
// import TrainMap1 from 'components/TrainMap1';
// import TrainMap2 from 'components/TrainMap2';
import StatusChart from 'components/inner/chart/StatusChart';
// import PieChart from 'components/inner/chart/PieChart';
// import DashboardBarChart from 'components/inner/chart/DashboardBarChart';
import { getEquipmentCtgrImageNameByCodeOfDashboard } from 'data/data';
import { DashboardAreaStackChart } from 'components/inner/chart/DashboardAreaStackChart';
import KakaoMap from 'components/KakaoMap';
import { getEquipmentAlertsByQueryString } from 'components/axios/equipmentAlertsAxios';
import AlertListCard from 'components/inner/mainCard/AlertListCard';
// import CCTVWebRTCLayer from 'components/layer/CCTVWebRTCLayer';

function DashboardMonitering() {
  const { getEnumValueByEnumName, equipmentCategoryLevel1s } = useEnumApi();
  const { t } = useTranslation();

  // const SubwayLineList = getEnumValueByEnumName("SubwayLine");
  const EquipmentFaultStatusList = getEnumValueByEnumName("EquipmentFaultStatus");

  // const [swTab, setSwTab] = useState('1');
  // const [subwayline, setSubwayline] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // const [subwaylineCount, setSubwaylineCount] = useState(0);
  // const [stationCount, setStationCount] = useState(0);
  // const [equipmentIotCount, setEquipmentIotCount] = useState(0);
  const [alertDatas, setAlertDatas] = useState(null);
  const [statusDatas, setStatusDatas] = useState(null);
  const [equipmentCtgrResult, setEquipmentCtgrResult] = useState([]);
  const [equipmentCtgr3Result, setEquipmentCtgr3Result] = useState([]);
  const [barData, setBarData] = useState({ xAxis: { type: 'category', data: [] }, yAxis: { type: 'value' }, series: [] });
  // const [pieDatas, setPieDatas] = useState([]);

  const location = useLocation();
  const timerRef = useRef(null);

  // useEffect(() => {
  //   console.log(location.pathname);
  //   if (location.pathname === '/auth/login') {
  //     // 로그인 페이지로 이동하면 타이머 정리
  //     clearTimeout(timerRef.current);
  //     console.log('타이머 정리 완료');
  //   }
    
  //   // return () => {
  //   //   console.log('out page')
  //   //   if (timerRef.current) clearTimeout(timerRef.current);
  //   // };
  // }, [location.pathname]);

  useEffect(() => {
    return () => {
      console.log('out page')
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  // const selectSubwayTab = (event, newValue) => {
  //   if (timerRef.current) clearTimeout(timerRef.current);
  //   setSwTab(newValue);
  //   if (newValue === '2')
  //     setSubwayline('I1');
  //   else if (newValue === '3')
  //     setSubwayline('I2');
  //   else
  //     setSubwayline('');
  //   setIsLoading(false);
  // };

  useEffect(() => {
    if (!isLoading && equipmentCategoryLevel1s?.length > 0) {
      repeatFunc();
    }
  // }, [isLoading, swTab, equipmentCategoryLevel1s]);
  }, [isLoading, equipmentCategoryLevel1s]);

  async function repeatFunc() {
    try {
      let stationParam = {};
      // let equipmentParam = { iotInstlYn: true };

      let alertParam = {
          page : 0,
          size : 5,
          "equipment.iotInstlYn" : true,
          AlertType:"IOT"
      };
      let addQueryString = "&sort=status,asc&sort=alertedAt,desc";
      let queryString = Object.entries(alertParam).map(([key, value]) => ( value && key+'='+value)).filter(v=>v).join('&');
      queryString += addQueryString;

      // setSubwaylineCount(SubwayLineList?.length)
      // if (swTab === '2') {
      //   stationParam['workingPart.subwayLine'] = 'I1';
      //   equipmentParam['station.workingPart.subwayLine'] = 'I1';
      //   setSubwaylineCount(1);
      // }
      // if (swTab === '3') {
      //   stationParam['workingPart.subwayLine'] = 'I2';
      //   equipmentParam['station.workingPart.subwayLine'] = 'I2';
      //   setSubwaylineCount(1)
      // }

      const [
        statusData,
        // stations,
        // equipments,
        monthlyAlerts,
        // equipmentAlerts
        equipmentAlerts
      ] = await Promise.all([
        getDashboardCountGroupByStatus(stationParam),
        // getStationsCount(stationParam),
        // getEquipmentsCount(equipmentParam),
        getDashboardCountEquipmentAlertGroupByMonthAndCategory1(stationParam),
        // getDashboardCountEquipmentAlertGroupByEquipmentCtgr1(stationParam)
        getEquipmentAlertsByQueryString("?"+queryString)
      ]);
      // console.log(equipmentAlerts)
      setAlertDatas(equipmentAlerts);
      setStatusDatas(statusData);
      // setStationCount(stations);
      // setEquipmentIotCount(equipments);
      
      // console.log(monthlyAlerts)
      // Update Bar Data
      const curMonth = dayjs();
      const alertBarCategories = Array.from({ length: 12 }, (_, i) => curMonth.subtract(11 - i, 'month').format('M'));
      const alertBarCategories2 = Array.from({ length: 12 }, (_, i) => curMonth.subtract(11 - i, 'month').format('YYYY_MM'));
      const alertBarSerieDatas = equipmentCategoryLevel1s.map((lvl1,k) => {
        const datas = alertBarCategories2.map((month, idx) => {
          const dataMonth = monthlyAlerts.find(d => d.id === lvl1.id && d.year == month.split('_')[0] && d.month == parseInt(month.split('_')[1]));
          return {value : dataMonth ? dataMonth.cnt : 0, 
            // link: `/equipment-alert-history-tracking?searchlevel1=${lvl1.id}&searchSubway=${subwayline}`
            link: `/equipment-alert-history-tracking?searchlevel1=${lvl1.id}`
            // itemStyle: {color: '#a90000'}
          };
        })
        // let color = '';
          // if (k === 0) {
          //   color = '#2d83b4';
          // } else if (k === 1) {
          //   color = '#e5a846';
          // } else if (k === 2) {
          //   color = '#ed1c24';
          // } else if (k === 3) {
          //   color = '#dddddd';
          // }
        return {
          name: lvl1.name,
          data: datas,
          // data: alertBarSerieDatas.map((data)=>{
          //   return {...data, itemStyle: {color: '#a9'+k+'0'+k+'0'}}
          // }),
          // itemStyle: {color: color}
        }
      });

      const alertBarLegends = equipmentCategoryLevel1s.map((lvl1,k) => {return lvl1.name})
      // console.log(alertBarLegends)
      setBarData({ legends:alertBarLegends, categories: alertBarCategories.map(month=>month + t('message.common.text.month2')), series: [alertBarSerieDatas] });

      // Update Pie Data
      // setPieDatas(equipmentCategoryLevel1s.map(lvl1 => ({
      //   title: lvl1.name,
      //   cnt: equipmentAlerts.find(d => d.name === lvl1.code)?.count || 0,
      //   link: `/equipment-alert-history-tracking?searchlevel1=${lvl1.id}&searchSubway=${subwayline}`
      // })));

      categoryStatusCount();
      setIsLoading(true);
    } catch (error) {
      console.error(error);
    } finally {
      timerRef.current = setTimeout(repeatFunc, 5000);
    }
  }

  function categoryStatusCount() {
    // console.log(isLoading)
    let equipmentParam = {iotInstlYn:true};
    let stationParam = {};
    // if (swTab === '2') {
    //   equipmentParam['station.workingPart.subwayLine'] = 'I1';
    //   stationParam['workingPart.subwayLine'] = 'I1';
    // }
    // if (swTab === '3') {
    //   equipmentParam['station.workingPart.subwayLine'] = 'I2';
    //   stationParam['workingPart.subwayLine'] = 'I2';
    // }

    const fetchData = async () => {

      getDashboardCountByCategoryAndEquipmentStatus().then((res)=>{
        // console.log(res)
        const res2 = res?.map((data)=> {
          return {...data, countTT: (data.countO1N + data.countO2I + data.countO3A)}
        })
        // console.log(res2)
        setEquipmentCtgr3Result(res2)
      })

      // try {
      //   const promises = equipmentCategoryLevel1s.map(async(item) => {
      //       const api1Result = await getEquipmentsCount({...equipmentParam, 'equipmentCtgr.parent.parent.code' : item.code});
      //       const api2Result = await getDashboardCountGroupByStatus({...stationParam, 'category.code' : item.code});
      //       // const api3Result = await getDashboardCountGroupByFollowActionType({...stationParam, 'category.code' : item.code});
      //       return {
      //         code : item.code
      //         , count : api1Result
      //         // , data : [...api2Result, ...api3Result]
      //         , data : [...api2Result]
      //       };
      //   });
      //   const responses = await Promise.all(promises);
      //   setEquipmentCtgrResult(responses);
      // } catch (error) {
      //   console.error('API 호출 중 오류 발생:', error);
      // }
    };
    fetchData();
  }

  return (
      <div className="main_container main_container1 cn_main_container">

        <div className='backun_status1'>
          <div className='backun_main_box1'>
            <MainCard content={false} className="cn_status_box">
              <div className='alert_phrase'>
                <div style={{display: "flex", alignItems: "center"}}>
                  <div style={{padding:"5px 10px"}}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.chip.dashboard.alert.list')} color="primary" />{/* <CCTVWebRTCLayer /> */}
                  </div>
                </div>

                <div className="charts_box2">
                  <AlertListCard equipmentAlerts={alertDatas?._embedded?.equipmentAlerts} />
                  {/* {(EquipmentFaultStatusList && statusDatas) && <StatusChart EquipmentFaultStatusList={EquipmentFaultStatusList} statusDatas={statusDatas} />} */}
                </div>
              </div>
            </MainCard>

            <MainCard content={false} className="cn_status_box">
              <div className='alert_phrase'>
                <div style={{display: "flex", alignItems: "center"}}>
                  <div style={{padding:"5px 10px"}}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.chip.situation.status')} color="primary" />
                  </div>
                </div>

                <div className="charts_box2">
                  {(EquipmentFaultStatusList && statusDatas) && <StatusChart EquipmentFaultStatusList={EquipmentFaultStatusList} statusDatas={statusDatas} />}
                </div>
              </div>
            </MainCard>
          </div>

          <div className='alert_phrase backun_main_box2'>
            <KakaoMap />
          </div>
        </div>

        <div className='backun_status2'>
          <MainCard className='backun_main_box3' content={false} style={{position:"relative", boxSizing: "border-box"}}>
            <div className='alert_phrase'>
              <div style={{display: "flex", alignItems: "center"}}>
                <div style={{padding:"5px 10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.chip.level3.status')} color="primary" />
                </div>
              </div>
              
              <div className="small_motion_box" style={{padding:"10px"}}>
                {equipmentCtgr3Result?.map((lvl3, l)=> {
                  return (
                <div key={l} className="small_motion_group">
                  <div className="small_motion1">
                    <div>
                      <div className='bgwhite' style={{textAlign:"center"}}>
                        <div className='backun_main_box3_tit'>* {lvl3.category3Name}</div>
                        <NavLink href={`/equipment?searchlevel1=${lvl3.category1Id}&searchlevel2=${lvl3.category2Id || ''}&searchlevel3=${lvl3.category3Id}`}>
                        <div className='main_motion'><img src={`${process.env.PUBLIC_URL}/img/small_motion/${getEquipmentCtgrImageNameByCodeOfDashboard(lvl3.category1Code)}`} alt='' /></div>
                        </NavLink>
                      </div>

                      <TableContainer className="table_part" style={{padding:"5px"}}>
                        <Table aria-label="simple table">
                          <TableBody>
                            <TableRow>
                              <TableCell>{t('message.common.total')}</TableCell>
                              <TableCell>{lvl3.countTT}</TableCell>
                              <TableCell>{t('message.common.title.alarm')}</TableCell>
                              <TableCell className='font_red'>{lvl3.countO3A}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>{t('message.common.normal')}</TableCell>
                              <TableCell className='font_blue'>{lvl3.countO1N}</TableCell>
                              <TableCell>{t('message.common.interest')}</TableCell>
                              <TableCell className='font_yellow'>{lvl3.countO2I}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer> 
                    </div>
                  </div>
                </div>
                  )
                })
                }

                {/* {equipmentCategoryLevel1s?.map((lvl1, l)=> {
                  const categoryData = equipmentCtgrResult && equipmentCtgrResult.find(ctgr => ctgr.code === lvl1.code);
                  let normalCnt = 0, alertCnt = 0, referCnt = 0;
                  if (categoryData) {
                    normalCnt = categoryData?.data?.reduce((acc, cur)=>{
                      if (cur.name === 'O1_N') {
                          return acc + cur.count;
                      }
                      return acc
                    },0);

                    alertCnt = categoryData?.data?.reduce((acc, cur)=>{
                      if (cur.name === 'O3_A') {
                          return acc + cur.count;
                      }
                      return acc
                    },0);

                    referCnt = categoryData?.data?.reduce((acc, cur)=>{
                      if (cur.name === 'O2_I') {
                          return acc + cur.count;
                      }
                      return acc
                    },0);
                  }
                  return (
                <div key={l} className="small_motion_group">
                  <div className="small_motion1">
                    <div>
                      <div className='bgwhite' style={{textAlign:"center"}}>
                        <div className='backun_main_box3_tit'>* {lvl1.name}</div>
                        <Link to={'/equipment?searchlevel1='+lvl1.id}>
                        <div className='main_motion'><img src={`${process.env.PUBLIC_URL}/img/small_motion/${getEquipmentCtgrImageNameByCodeOfDashboard(lvl1.code)}`} alt='' /></div>
                        </Link>
                      </div>

                      <TableContainer className="table_part" style={{padding:"5px"}}>
                        <Table aria-label="simple table">
                          <TableBody>
                            <TableRow>
                              <TableCell>{t('message.common.total')}</TableCell>
                              <TableCell>{categoryData?.count || 0}</TableCell>
                              <TableCell>{t('message.common.title.alarm')}</TableCell>
                              <TableCell className='font_red'>{alertCnt}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>{t('message.common.normal')}</TableCell>
                              <TableCell className='font_blue'>{normalCnt}</TableCell>
                              <TableCell>{t('message.common.interest')}</TableCell>
                              <TableCell className='font_yellow'>{referCnt}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer> 

                    </div>
                  </div>
                </div>
                  )
                })} */}
              </div>
            </div>
          </MainCard>

          <MainCard className='backun_main_box4' content={false} style={{position:"relative", boxSizing: "border-box"}}>
            <div className='alert_phrase'>
              <div style={{display: "flex", alignItems: "center"}}>
                <div style={{padding:"5px 10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.chip.business.company.status')} color="primary" />
                </div>
              </div>
              
              <div className="charts_box2">
                {barData && <DashboardAreaStackChart barData={barData} />}
              </div>
            </div>
          </MainCard>
        </div>
      </div>
    )
  // }
}

export default DashboardMonitering;
